import React from 'react';

export default ({ color = '#221CB6', size = 14 }): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00065 0.583008C4.42332 0.583008 2.33398 2.67235 2.33398 5.24967C2.33398 6.69617 2.9921 7.98895 4.02524 8.84493L3.50574 12.7562C3.47625 12.9782 3.57651 13.1975 3.76373 13.3205C3.95094 13.4435 4.19204 13.4484 4.38412 13.3332L7.00067 11.7633L9.61721 13.3332C9.80927 13.4484 10.0504 13.4435 10.2376 13.3206C10.4248 13.1976 10.5251 12.9783 10.4956 12.7563L9.9766 8.84449C11.0094 7.9885 11.6673 6.69592 11.6673 5.24967C11.6673 2.67235 9.57798 0.583008 7.00065 0.583008ZM5.11267 9.51866C5.6899 9.77432 6.32869 9.91634 7.00065 9.91634C7.6728 9.91634 8.31176 9.77424 8.88913 9.51844L9.17993 11.7103L7.54089 10.7268L7.52393 10.7165C7.46249 10.6788 7.33509 10.6007 7.18834 10.5685C7.0647 10.5413 6.93663 10.5413 6.81299 10.5685C6.66625 10.6007 6.53884 10.6788 6.4774 10.7165L6.46044 10.7268L4.82159 11.7101L5.11267 9.51866Z"
        fill={color}
      />
    </svg>
  );
};
